import { createWidget } from '@alfa-bank/site-util-create-widget';

import { InputField as Component } from './input-field';
import type { IProps } from './models';

export const InputField = createWidget<unknown, IProps>()(Component);
